import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-venue-poc-details',
  standalone: false,
  templateUrl: './venue-poc-details.component.html',
  styleUrl: './venue-poc-details.component.scss',
})
export class VenuePocDetailsComponent {
  @Input() data: any;
  @Input() isVisible = false;
  @Output() closeModal = new EventEmitter<void>();

  handleCancel(): void {
    this.closeModal.emit();
  }
}
